// Help API 模块

import service from '@/utils/https';
import type { AxiosResponse } from 'axios';
import type { ApiResponse } from '@/types';
import type { HelpRequestCreate, HelpRequestSubmitResponse } from '@/types/help';
import type { FileUploadUrlRequest, PresignedUploadUrlResponse } from '@/types/aws';

/**
 * 提交 Help 请求
 * @param data - Help 请求数据
 * @returns Promise<AxiosResponse<ApiResponse<HelpRequestSubmitResponse>>>
 */
export function submitHelpRequest(data: HelpRequestCreate): Promise<AxiosResponse<ApiResponse<HelpRequestSubmitResponse>>> {
  return service({
    url: '/v1/help',
    method: 'post',
    data,
  });
}

/**
 * 获取 Help 附件上传 URL
 * @param data - 上传文件信息
 * @returns Promise<AxiosResponse<ApiResponse<PresignedUploadUrlResponse>>>
 */
export function getHelpAttachmentUploadUrl(data: FileUploadUrlRequest): Promise<AxiosResponse<ApiResponse<PresignedUploadUrlResponse>>> {
  return service({
    url: '/v1/help/attachment-upload-url',
    method: 'post',
    data,
  });
}
